<template>
  <div class="app-radio">
    <label class="app-radio__item">
      <input
        class="app-radio__core"
        type="radio"
        :name="name"
        :disabled="disabled"
        :checked="modelValue === radioValue"
        @change="onChange"
      />
      <div
        :class="{
          'app-radio__item-label': true,
          [`app-radio__item-label__${props.size}`]: true,
          'app-radio__item-label__disabled': props.disabled,
          // 'app-radio__item-label__disabled-checked':
          // 	props.disabled && props.value,
        }"
      />
      <span
        :class="{
          'app-radio__item-text': true,
          [`app-radio__item-text__${props.size}`]: true,
        }"
      >
        {{ props.text }}
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
type radioProps = {
  modelValue: boolean | null;
  radioValue: boolean | null;
  name: string;
  disabled?: boolean;
  size?: "md" | "lg";
  text?: string;
};

type radioEmit = {
  "on-change": [event: object];
  "on-input": [value: boolean];
  input: [value: boolean];
};

const props = withDefaults(defineProps<radioProps>(), {
  size: "md",
  text: "Text",
  value: false,
  valueOff: false,
  valueOn: true,
});

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean | null): void;
}>();
const onChange = () => {
  emit("update:modelValue", props.radioValue);
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";

.app-radio {
  &__core {
    height: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    width: 0;
  }

  &__core:checked ~ .app-radio__item-label {
    background-color: $background-white;
    border: 1px solid $color-accent;

    &:hover {
      // background-color: $white-50;
      border: 1px solid $color-accent;
    }

    // &:active {
    // 	background-color: $white-50;
    // 	border: 1px solid $indigo-700;
    // }
    // &__disabled-checked {
    // 	border: 1px solid $color-border;
    // 	background-color: $color-divider;
    // 	cursor: default;
    // 	// &:hover {
    // 	// 	border: 1px solid $zinc-400;
    // 	// 	background-color: $zinc-600;
    // 	// }
    // 	// &:active {
    // 	// 	border: 1px solid $zinc-400;
    // 	// 	background-color: $zinc-600;
    // 	// }
    // }
  }

  &__core:checked ~ &__item-label::before {
    opacity: 1;
  }

  &__item {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    cursor: pointer;
  }

  &__item-label {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 1px solid $color-border;
    border-radius: 50%;
    transition: all 0.3s ease;

    &__md {
      height: 16px;
      width: 16px;

      &::before {
        background-color: $color-accent;
        border-radius: 50%;
        content: "";
        height: 6px;
        opacity: 0;
        width: 6px;
      }
    }

    // &__lg {
    // 	height: 24px;
    // 	width: 24px;
    // 	&::before {
    // 		background-color: $background-white;
    // 		border-radius: 50%;
    // 		content: "";
    // 		height: 12px;
    // 		opacity: 0;
    // 		width: 12px;
    // 	}
    // }

    &:hover {
      border: 1px solid $color-accent;
    }

    // &:active {
    // 	border: 1px solid $indigo-700;
    // }

    &__disabled {
      cursor: default;
      border: 1px solid $color-border;
      background-color: $color-divider;

      &:hover {
        border: 1px solid $color-border;
      }

      // &:active {
      // 	border: 1px solid $zinc-400;
      // }
    }

    // &__disabled-checked {
    // 	border: 1px solid $zinc-400;
    // 	background-color: $zinc-600;
    // 	cursor: default;
    // 	&:hover {
    // 		border: 1px solid $zinc-400;
    // 		background-color: $zinc-600;
    // 	}
    // 	&:active {
    // 		border: 1px solid $zinc-400;
    // 		background-color: $zinc-600;
    // 	}
    // 	&::before {
    // 		background-color: $zinc-400;
    // 	}
    // }
  }

  &__item-text {
    box-sizing: content-box;
    vertical-align: middle;
    padding-left: 8px;
    user-select: none;
    // font-family: "Manrope", sans-serif;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: $color-text_main;

    &__md {
      font-size: 14px;
      line-height: 20px;
    }

    // &__lg {
    // 	font-size: 24px;
    // 	line-height: 24px;
    // }
  }
}
</style>
